export const headerHeight = '60px';
export const mobileHeaderHeight = '50px';
export const footerHeight = '50px';

export const appMinWidth = '720px';

export const breakpoints = {
  SCREEN_S:  '@media only screen and (max-width: 480px)',
  SCREEN_XS: '@media only screen and (max-width: 320px)',
}




// WEBPACK FOOTER //
// ./src/styles/constants.js